module.exports = __webpack_public_path__ + "static/fonts/barlowcondensed-medium-webfont.686c9d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-medium-webfont.ttf
// module id = 354
// module chunks = 0